import OfferingDetails from "./OfferingDetails";

export default OfferingDetails;
